import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { scriptMessages as messages } from '../../messages/scriptMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the script step; each part uses its own slice of it */
import styles from './Script.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PhoneShotSheetProps {
  number: number;
  canRewrite: boolean;
  canRemove: boolean;
  onEdit: () => void;
  onRewrite: () => void;
  onAdd: () => void;
  onRemove: () => void;
  onClose: () => void;
}

/** The "…" menu of a shot on a phone (design j3): edit, rewrite, add a shot after it, remove. */
const PhoneShotSheetComponent: React.FC<PhoneShotSheetProps> = ({
  number,
  canRewrite,
  canRemove,
  onEdit,
  onRewrite,
  onAdd,
  onRemove,
  onClose,
}) => {
  const intl = useIntl();
  const item = (label: string, onClick: () => void, disabled = false, danger = false) => (
    <button
      type="button"
      className={clsx(styles.sheetItem, danger && styles.sheetDanger)}
      disabled={disabled}
      onClick={() => {
        onClose();
        onClick();
      }}
    >
      {label}
    </button>
  );
  return (
    <>
      <button
        type="button"
        className={styles.sheetBackdrop}
        tabIndex={-1}
        aria-label={intl.formatMessage(messages.sheetClose)}
        onClick={onClose}
      />
      <div
        className={styles.sheet}
        role="dialog"
        aria-modal="true"
        aria-label={intl.formatMessage(messages.sheetTitle, { number })}
      >
        <i className={styles.grab} aria-hidden />
        <h4>{intl.formatMessage(messages.sheetTitle, { number })}</h4>
        {item(intl.formatMessage(messages.sheetEdit), onEdit)}
        {item(intl.formatMessage(messages.rewriteShot), onRewrite, !canRewrite)}
        {item(intl.formatMessage(messages.sheetAdd), onAdd)}
        {item(intl.formatMessage(messages.remove), onRemove, !canRemove, true)}
        {item(intl.formatMessage(messages.sheetClose), () => undefined)}
      </div>
    </>
  );
};

export const PhoneShotSheet = TypedMemo(PhoneShotSheetComponent);
